// Props for the Segment Icon category tab strip.
//
// WHY THIS EXISTS: the strip carries 21 categories ("All", "People", "Health",
// "Fitness & Sports", … "Symbols", "Other"). The shared <Tabs> component
// defaults to MUI's `variant="fullWidth"`, which divides the track into equal
// slices regardless of how much room the labels need. Measured live on
// web-stg.iyuga.net, bundle main.34fb621d.js, 2026-07-31, at a 1440px viewport
// with the Segment Settings pane open:
//
//   tablist track            354.0px wide, scrollWidth 584px
//   every tab                24.0px wide, overflow:hidden, text-overflow:clip
//   "People" label needs     41.5px      "Health" needs   39.8px
//   "Arrows" label needs     42.9px      "Symbols" needs  52.6px
//   "Other"  label needs     35.5px
//   -> scrollWidth > clientWidth on 20 of the 21 tabs (only "All", 15px, fits)
//
// Worse than clipping: the strip's parent is overflow-x:hidden and the strip
// itself is not scrollable, so the last four categories ("Text & Editing",
// "Arrows", "Symbols", "Other") lay out at x 1429.6-1537.6 — past the 1440px
// viewport. Measured: 6 of 21 tabs fail a document.elementFromPoint() hit test
// at their own centre; 25 ArrowRight presses moved focus out of the tablist
// without scrolling it (scrollLeft stayed 0), and a horizontal wheel over the
// strip also left scrollLeft at 0. Those categories cannot be reached by
// mouse, keyboard or scroll.
//
// Making the strip scrollable gives every tab its intrinsic width and adds
// scroll buttons for the overflow, which is how MUI intends a long strip to
// behave. Nothing else about the picker changes.
const ICON_CATEGORY_TAB_PROPS = {
  variant: "scrollable",
  scrollButtons: true,
  allowScrollButtonsMobile: true,
};

export default ICON_CATEGORY_TAB_PROPS;
